import React, { useState, useEffect, Children } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { getAssessmentReportPage } from '../../redux/actions/assessment'
import AssessmentReportDynamicWidgets from '../../widgets/assessment/AssessmentReportDynamicWidgets'

export default function ReprotHealthPromotionProject() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const reprotType = 3

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentReportPage(reprotType, 1, 5)
      setSchema(response)
      // setSchema(mocSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema && <AssessmentReportDynamicWidgets schema={schema} type={reprotType} />}
    </SidebarProposal>
  )
}

const mocSchema = {
  header: 'โครงการสร้างเสริมสุขภาพ',
  searchForm: [
    {
      name: 'budgetYear',
      label: 'ปีงบประมาณ',
      type: '1',
    },
    {
      name: 'node',
      label: 'Node',
      type: '2',
      options: [
        { label: 'Node จังหวัด', value: '1' },
        { label: 'Node จังหวัด', value: '2' },
        { label: 'Node เปราะบาง', value: '3' },
      ],
    },
    {
      name: 'region',
      label: 'ภาค',
      type: '2',
      options: [
        { label: 'เหนือ', value: '1' },
        { label: 'ใต้', value: '2' },
        { label: 'ออก', value: '3' },
      ],
    },
    {
      name: 'projectCode',
      label: 'รหัสโครงการ',
      type: '1',
    },
  ],
  resultData: {
    columnConfig: [
      {
        key: 'budgetYear',
        label: 'ปีงบประมาณ',
        width: 120,
        align: 'center',
        seq: 1,
      },
      {
        key: 'node',
        label: 'Node',
        align: 'center',
        width: 120,
        seq: 1,
      },
      {
        key: 'projectCode',
        label: 'รหัสโครงการ',
        width: 300,
        seq: 1,
      },
      {
        key: 'projectName',
        label: 'ชื่อโครงการ',
        width: 300,
        seq: 1,
      },
      {
        key: 'region',
        label: 'ภาค',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'province',
        label: 'จังหวัด',
        align: 'right',
        width: 200,
        seq: 1,
      },
      {
        key: 'district',
        label: 'อำเภอ',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'subDistrict',
        label: 'ตำบล',
        align: 'center',
        width: 150,
        seq: 1,
      },
      {
        key: 'addressName',
        label: 'ชื่อหมู่บ้าน/สถานศึกษา',
        width: 200,
        seq: 1,
      },
      {
        key: 'issue',
        label: 'ประเด็น',
        width: 200,
        seq: 1,
      },
      {
        key: 'projectLeader',
        label: 'จำนวนแกนนำโครงการ',
        width: 200,
        seq: 1,
      },
      {
        key: 'targetGroupPerson',
        label: 'จำนวนกลุ่มเป้าหมายที่ได้รับประโยชน์ (คน)',
        width: 200,
        seq: 1,
      },
      {
        key: 'targetGroupHousehold',
        label: 'จำนวนกลุ่มเป้าหมายที่ได้รับประโยชน์ (ครัวเรือน)',
        width: 200,
        seq: 1,
      },
      {
        key: 'behavioralChangePerson',
        label: 'ข้อมูลการปรับเปลี่ยนพฤติกรรม (คน)',
        width: 200,
        seq: 1,
      },
      {
        key: 'behavioralChangeHousehold',
        label: 'ข้อมูลการปรับเปลี่ยนพฤติกรรม (ครัวเรือน)',
        width: 200,
        seq: 1,
      },
      {
        key: 'environmentSociety',
        label: 'ข้อมูลสภาพแวดล้อม (สังคม)',
        width: 200,
        seq: 1,
      },
      {
        key: 'environmentPhysical',
        label: 'ข้อมูลสภาพแวดล้อม (กายภาพ)',
        width: 200,
        seq: 1,
      },
      {
        key: 'innovationPrototypeArea',
        label: 'จำนวนนวัตกรรม/พื้นที่ต้นแบบ',
        width: 200,
        seq: 1,
      },
    ],
    total: 2,
    values: [
      {
        rowNum: 1,
        budgetYear: '1',
        node: '1',
        projectCode: '2',
        projectName: '3',
        region: '2025',
        province: 100000,
        district: '',
        subDistrict: '',
        addressName: '',
        issue: '',
        projectLeader: '',
        targetGroupPerson: '',
        targetGroupHousehold: '',
        behavioralChangePerson: '',
        behavioralChangeHousehold: '',
        environmentSociety: 20,
        environmentPhysical: 10,
        innovationPrototypeArea: 10,
      },
      {
        rowNum: 1,
        budgetYear: '1',
        node: '1',
        projectCode: '2',
        projectName: '3',
        region: '2025',
        province: 100000,
        district: '',
        subDistrict: '',
        addressName: '',
        issue: '',
        projectLeader: '',
        targetGroupPerson: '',
        targetGroupHousehold: '',
        behavioralChangePerson: '',
        behavioralChangeHousehold: '',
        environmentSociety: 20,
        environmentPhysical: 10,
        innovationPrototypeArea: 10,
      },
    ],
  },
}
